<script setup lang="ts">
import { useSettingsStore } from '@/dashboard/store/settingsStore';
import { storeToRefs } from 'pinia';

const settingsStore = useSettingsStore();

const { isShowSaveChangesBanner, isShowSaveChangesLoader, isSavedChanges } = storeToRefs(settingsStore);
</script>

<template>
  <div
    :class="{ 'bottom-[0]': isShowSaveChangesBanner, 'bottom-[-130px]': !isShowSaveChangesBanner }"
    class="fixed left-zero flex h-[128px] w-full flex-col bg-white transition-[bottom] duration-[375ms] ease-out dark:bg-gray-900 max-tablet:h-[74px]"
  >
    <div class="tppr-divider tppr-divider__black max-tablet:hidden"></div>

    <div class="flex flex-1 items-center justify-end gap-[12px] pr-l max-tablet:justify-center max-tablet:gap-[7px] max-tablet:pr-zero">
      <button
        class="tppr-button ghost xl max-w-[224px] max-tablet:hidden max-tablet:max-w-[168px]"
        :disabled="isShowSaveChangesLoader || isSavedChanges"
        @click="settingsStore.discardChanges"
      >
        <span class="tppr-button__text">Discard <span class="max-tablet:hidden">changes</span></span>
      </button>
      <button
        class="tppr-button sl info-tip s2 max-w-[224px] max-tablet:max-w-[168px] laptop:hidden"
        :disabled="isShowSaveChangesLoader || isSavedChanges"
        @click="settingsStore.discardChanges"
      >
        <span class="tppr-button__text">Discard <span class="max-tablet:hidden">changes</span></span>
      </button>

      <button
        class="tppr-button xl max-tablet:sl max-w-[224px] max-tablet:max-w-[168px]"
        :class="{ '!bg-brand-night-blue': isShowSaveChangesLoader || isSavedChanges }"
        :disabled="isShowSaveChangesLoader || isSavedChanges"
        @click="settingsStore.saveChanges"
      >
        <span v-if="!isShowSaveChangesLoader && !isSavedChanges" class="tppr-button__text">Save changes</span>
        <span v-if="!isShowSaveChangesLoader && isSavedChanges" class="tppr-button__text">Saved!</span>
        <svg v-if="isShowSaveChangesLoader" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22 22" fill="none" class="rotate">
          <path
            class="stroke-white"
            d="M20.5832 11C20.5832 16.2927 16.2926 20.5834 10.9998 20.5834C5.70711 20.5834 1.4165 16.2927 1.4165 11C1.4165 5.70729 5.70711 1.41669 10.9998 1.41669"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>
